import React, { useRef, useState, useEffect } from "react";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "../redux/hook";
import { sendEmail } from "../redux/actions/sendEmailAction";

import contactImage from "../assets/images/contact.svg";

export default function Contact() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [sendingEmail, setSendingEmail] = useState(false);

  const [form, setForm] = React.useState({
    name: "",
    email: "",
    subject: "",
    comments: "",
  });

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  // Check if all fields are non-empty
  const isFormValid =
    form.name?.trim() !== "" &&
    form.email?.trim() !== "" &&
    form.subject?.trim() !== "" &&
    form.comments?.trim() !== "" &&
    form.userCaptcha?.trim() !== "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();

    setSendingEmail(true);

    let user_captcha_value = document.getElementById("userCaptcha").value;

    if (validateCaptcha(user_captcha_value) === true) {
      try {
        const emailData = {
          subject: form.subject,
          name: form.name,
          email: form.email,
          message: form.comments,
        };

        const result = await dispatch(sendEmail(emailData));

        if (result.payload === "email_sent_successfully") {
          alert(`${t("common.email_sent_successfully")}`);
        } else {
          alert(`${t("common.email_sent_unsuccessfully")}`);
        }
        setSendingEmail(false);
      } catch (error) {
        alert(`${t("common.email_sent_unsuccessfully")}`);
        setSendingEmail(false);
      }
    } else {
      alert("Insira as letras corretas");
      setSendingEmail(false);
    }
  };

  return (
    <>
      {sendingEmail && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.3)", // semi-transparent overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <div className="container relative md:mt-24 mt-16">
        <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
          <img src={contactImage} alt="" />

          <div className="lg:ms-5">
            <div className="bg-white dark:bg-slate-900 rounded-xl shadow dark:shadow-gray-700 p-6">
              <h3 className="mb-6 text-2xl leading-normal font-medium">
                {t("external.contact_us.contact_us")}
              </h3>

              <form onSubmit={onSubmitForm}>
                <div className="grid lg:grid-cols-12 lg:gap-6">
                  <div className="lg:col-span-6 mb-5">
                    <label htmlFor="name" className="form-label font-medium">
                      {t("external.contact_us.name")}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      value={form.name}
                      onChange={handleChange}
                      className="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2"
                      placeholder="Name :"
                    />
                  </div>
                  <div className="lg:col-span-6 mb-5">
                    <label htmlFor="email" className="form-label font-medium">
                      {t("external.contact_us.email")}
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      className="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2"
                      placeholder="Email :"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1">
                  <div className="mb-5">
                    <label htmlFor="subject" className="form-label font-medium">
                      {t("external.contact_us.subject")}
                    </label>
                    <input
                      name="subject"
                      id="subject"
                      value={form.subject}
                      onChange={handleChange}
                      className="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2"
                      placeholder="Subject :"
                    />
                  </div>
                  <div className="mb-5">
                    <label
                      htmlFor="comments"
                      className="form-label font-medium"
                    >
                      {t("external.contact_us.comment")}
                    </label>
                    <textarea
                      name="comments"
                      id="comments"
                      value={form.comments}
                      onChange={handleChange}
                      className="form-input w-full py-2 px-3 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2 textarea h-28"
                      placeholder="Message :"
                    ></textarea>
                  </div>
                  <div className="mb-5">
                    <LoadCanvasTemplate />
                  </div>
                  <div className="mb-5">
                    <input
                      name="userCaptcha"
                      id="userCaptcha"
                      value={form.userCaptcha}
                      onChange={handleChange}
                      className="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2"
                      placeholder="Captcha :"
                    />
                  </div>
                </div>
                {!isFormValid || sendingEmail ? (
                  <button
                    type="submit"
                    id="submit"
                    name="send"
                    disabled={!isFormValid || sendingEmail}
                    className={`py-2 px-5 inline-block font-normal tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-gray-500 hover:bg-gray-600 border-gray-500 hover:border-gray-600 text-black rounded-xl ${
                      !isFormValid ? "opacity-90 cursor-not-allowed" : ""
                    }`}
                  >
                    {t("external.contact_us.send")}
                  </button>
                ) : (
                  <button
                    type="submit"
                    id="submit"
                    name="send"
                    disabled={!isFormValid || sendingEmail}
                    className={`py-2 px-5 inline-block font-normal tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white rounded-xl ${
                      !isFormValid ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    {t("external.contact_us.send")}
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
